<template>
  <v-container >
    <v-dialog
      v-model="dialogAddAlumno.estatus"
      persistent
      max-width="800"
    >
      <v-card >
        <v-stepper alt-labels v-model="steppers.paso">
		      <v-stepper-header>
		        <v-stepper-step
		        	:complete="steppers.paso > 1"
        			step="1"
        		>
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mx-2"
                  color="primary"
                  @click="dialogAyuda = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-alert-circle
                </v-icon>
              </template>
              <span>Ver ayuda sobre el registro de datos del alumno</span>
            </v-tooltip>
		          Datos generales
		        </v-stepper-step>

		        <v-divider></v-divider>

		        <v-stepper-step
		        	:complete="steppers.paso > 2"
		        	step="2"
		        >
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mx-2"
                  color="primary"
                  @click="dialogAyudaSeleccionarGrupo = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-alert-circle
                </v-icon>
              </template>
              <span>Ver ayuda sobre la selección de grupo</span>
            </v-tooltip>
		          Seleccionar grupo
		        </v-stepper-step>

		        <v-divider></v-divider>

		        <v-stepper-step 
		        	:complete="steppers.paso > 3"
		        	step="3"
		        >
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mx-2"
                  color="primary"
                  @click="dialogAyudaRealizarPago = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-alert-circle
                </v-icon>
              </template>
              <span>Ver ayuda sobre el proceso de pago</span>
            </v-tooltip>
		          Realizar pago
		        </v-stepper-step>
		      </v-stepper-header>

		      <v-stepper-items>

		      	<!-- Datos generales del alumno -->
			      <v-stepper-content step="1">
			        <v-card>
			        	<NuevoAlumno
			        		:infoAlumno="infoAlumno"
			        		:steppers="steppers"
                  :hermanos="hermanos"
			        		:alumno="alumno"
			        		:dialogAddAlumno="dialogAddAlumno"
			        		:tutor="tutor"
                  :seleccionTipoAlumno="seleccionTipoAlumno"
			        		v-if="steppers.paso == 1"
			        	/>
			        </v-card>
			      </v-stepper-content>

			      <v-stepper-content step="2">
			        <v-card>

                <!-- Agregar grupo a nuevos hermanos -->
			        	<SeleccionaGrupoHermanos
			        		:infoAlumno="infoAlumno"
			        		:steppers="steppers"
			        		:hermanos="hermanos"
			        		:dialogAddAlumno="dialogAddAlumno"
			        		:tutor="tutor"
                  :alumno="alumno"
			        		v-if="steppers.paso == 2 && seleccionTipoAlumno.opTipoAlumno == 2 && seleccionTipoAlumno.opAlumno == 2 "
			        	/>

                <!-- Agregar grupo a nuevo alumno -->
                <SeleccionaGrupoAlumno
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :dialogAddAlumno="dialogAddAlumno"
                  :tutor="tutor"
                  :alumno="alumno"
                  v-if="steppers.paso == 2 && seleccionTipoAlumno.opTipoAlumno == 2 && seleccionTipoAlumno.opAlumno == 1 "
                />

                <!-- agregar grupo a hermnaos RI -->
                <SeleccionaGrupoHermanosRI
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :dialogAddAlumno="dialogAddAlumno"
                  :tutor="tutor"
                  :alumno="alumno"
                  v-if="steppers.paso == 2 && seleccionTipoAlumno.opTipoAlumno == 1 && seleccionTipoAlumno.opAlumno == 2 "
                />

                <!-- agregar grupo a alumno RI -->
                <SeleccionaGrupoAlumnoRI
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :dialogAddAlumno="dialogAddAlumno"
                  :tutor="tutor"
                  :alumno="alumno"
                  v-if="steppers.paso == 2 && seleccionTipoAlumno.opTipoAlumno == 1 && seleccionTipoAlumno.opAlumno == 1 "
                />

			        </v-card>
			      </v-stepper-content>

			      <v-stepper-content step="3">
			        <v-card>

                <!-- Agregar Pago a nuevos hermanos -->
			        	<RealizarPagoHermanos
			        		:infoAlumno="infoAlumno"
			        		:steppers="steppers"
			        		:hermanos="hermanos"
			        		:tutor="tutor"
			        		:dialogAddAlumno="dialogAddAlumno"
			        		v-if="steppers.paso == 3 && !steppers.factura && !steppers.app && seleccionTipoAlumno.opTipoAlumno == 2 && seleccionTipoAlumno.opAlumno == 2 "
			        	/>

                <!-- Agregar Pago a nuevo alumno -->
                <RealizarPagoAlumno
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :alumno="alumno"
                  :tutor="tutor"
                  :dialogAddAlumno="dialogAddAlumno"
                  v-if="steppers.paso == 3 && !steppers.factura && !steppers.app && seleccionTipoAlumno.opTipoAlumno == 2 && seleccionTipoAlumno.opAlumno == 1 "
                />

                <!-- agregar Pago a hermnaos RI -->
                <RealizarPagoHermanosRI
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :tutor="tutor"
                  :dialogAddAlumno="dialogAddAlumno"
                  v-if="steppers.paso == 3 && !steppers.factura && !steppers.app && seleccionTipoAlumno.opTipoAlumno == 1 && seleccionTipoAlumno.opAlumno == 2 "
                />

                <!-- agregar Pago a alumno RI -->
                <RealizarPagoAlumnoRI
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :alumno="alumno"
                  :tutor="tutor"
                  :dialogAddAlumno="dialogAddAlumno"
                  v-if="steppers.paso == 3 && !steppers.factura && !steppers.app && seleccionTipoAlumno.opTipoAlumno == 1 && seleccionTipoAlumno.opAlumno == 1 "
                />

                <!-- agregar Pago a alumno UNICO SOLO FACTURA -->
                <RealizarPagoAlumnoRIF
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :alumno="alumno"
                  :tutor="tutor"
                  :dialogAddAlumno="dialogAddAlumno"
                  v-if="steppers.paso == 3 && steppers.factura && !steppers.app && seleccionTipoAlumno.opTipoAlumno == 1 && seleccionTipoAlumno.opAlumno == 1 "
                />

                <!-- agregar Pago a alumno UNICO SOLO APP -->
                <RealizarPagoAlumnoRIA
                  :infoAlumno="infoAlumno"
                  :steppers="steppers"
                  :hermanos="hermanos"
                  :alumno="alumno"
                  :tutor="tutor"
                  :dialogAddAlumno="dialogAddAlumno"
                  v-if="steppers.paso == 3 && steppers.app && seleccionTipoAlumno.opTipoAlumno == 1 && seleccionTipoAlumno.opAlumno == 1 "
                />

			        </v-card>
			      </v-stepper-content>
			    </v-stepper-items>

		    </v-stepper>
      </v-card>
    </v-dialog>

    <!-- Ver evidencias -->
    <v-dialog v-model="dialogImagen" max-width="1000px">
      <v-card class="elevation-0">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom color="blue" max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab small text @click="dialogImagen = false" v-bind="attrs" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Cerrar vista de imagen</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-img
            :src=" url + imagen" 
            contain
            max-height="80vh"
          >
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAyuda" max-width="900">
      <v-card>
        <v-card-title class="text-h5">Ayuda — Documentación</v-card-title>
        
        <v-card-text>

          <div class="flex">
            <v-radio-group row>
	            <v-radio
	              label="RI"
	              :value="1"
	            ></v-radio>
	          </v-radio-group>RI (Reingreso): Identifica a los alumnos de ciclos anteriores que se inscriben nuevamente para cursar el siguiente nivel
          </div>

          <div class="flex">
            <v-radio-group row>
	            <v-radio
	              label="NI"
	              :value="2"
	            ></v-radio>
	          </v-radio-group>NI (Nuevo Ingreso): Esta clasificación agrupa a los estudiantes que se incorporan por primera vez
          </div>

          <div class="flex">
            <v-radio-group row>
	            <v-radio
	              label="Único"
	              :value="1"
	            ></v-radio>
	          </v-radio-group>
          </div>

          <div class="flex">
            <v-radio-group row>
	            <v-radio
	              label="Hermanos"
	              :value="2"
	            ></v-radio>
	          </v-radio-group>
          </div>

          <div class="flex">
            <v-text-field
								  filled 
								  dense
								  hide-details
								  label="Seleccione el alumno"
								></v-text-field>A través de esta herramienta, el usuario puede identificar al alumno mediante sus datos de identificación (nombre o matrícula) para proceder con el pago
          </div>

          <div class="flex">
            <v-text-field
								  filled 
								  dense
								  hide-details
								  label="Nombre"
								></v-text-field>el sistema desplegará automáticamente el nombre  del estudiante, permitiendo al usuario verificar que la identidad sea correcta antes de proceder.
          </div>

          <div class="flex">
            <v-text-field
								  filled 
								  dense
								  hide-details
								  label="Ap. paterno"
								></v-text-field>De manera complementaria, el sistema mostrará el apellido paterno
          </div>

          <div class="flex">
            <v-text-field
								  filled 
								  dense
								  hide-details
								  label="Ap. Materno"
								></v-text-field>Asimismo, el sistema mostrará el apellido materno, completando así el nombre íntegro
          </div>

          <div class="flex">
            <v-text-field
								  filled 
								  dense
								  hide-details
								  label="Edad"
								></v-text-field>Finalmente, presentará la edad del alumno
          </div>

          <div class="flex">
            <v-text-field
								  filled 
								  dense
								  hide-details
								  label="Teléfono"
								></v-text-field>
            Se visualizará el número telefónico registrado como contacto principal
          </div>

          <div class="flex">
            <v-text-field
								  filled 
								  dense
								  hide-details
								  label="Celular"
								></v-text-field>
            De igual manera, el sistema mostrará el número celular registrado del contacto
          </div>

          <div class="flex">
            <v-btn text >Cancelar</v-btn>
            Al seleccionar el botón Cancelar, el sistema interrumpirá la acción actual y redirigirá al usuario al panel principal de inscripciones
          </div>

          <div class="flex">
            <v-btn tile color="primary">
              Siguiente
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
            Al hacer clic en Siguiente, el usuario confirma que ha validado la identidad y los datos de contacto del alumno
          </div>

          <div class="flex">
            <v-btn tile color="white">
              Datos del hermano 1 y 2
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
            Este módulo permite gestionar el cobro para alumnos que cuentan con el descuento por hermandad. Tras localizar al primer estudiante en el buscador, la plataforma habilitará la vista de los siguientes hermanos registrados. Esto asegura que la bonificación se aplique correctamente a los alumnos de manera simultánea
          </div>


    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green darken-1" text @click="dialogAyuda = false" v-bind="attrs" v-on="on">
            Cerrar
          </v-btn>
        </template>
        <span>Cerrar ventana de ayuda</span>
      </v-tooltip>
    </v-card-actions>

  </v-card>
    </v-dialog>
    

    <v-dialog v-model="dialogAyudaSeleccionarGrupo" max-width="900">
      <v-card>
        <v-card-title class="text-h5">Ayuda — Documentación</v-card-title>
        
        <v-card-text>

          <div class="flex">
            <b>Datos del alumno</b>Aquí corroboraremos la matricula del alumno

          </div>

          <div class="flex">
            <b>Grupo Actual del alumno</b>Verificaremos el grupo en el que actualmente se encuentra inscrito el alumno 
          </div>

          <div class="flex">
            <b>Grupo siguiente</b>En esta sección, se debe validar que el grupo asignado sea el correcto, prestando especial atención a la nomenclatura para asegurar que el pago se registre en el nivel y horario correspondientes.
          </div>

          <div class="flex">
            <v-btn color="primary" text>
             Regresar
            </v-btn>El botón Regresar permite volver a la pantalla de búsqueda anterior, facilitando la selección de un nuevo alumno o la corrección de la matrícula en caso de que los datos desplegados no coincidan con el estudiante solicitado
          </div>

          <div class="flex">
            <v-btn color="primary" text>
             Siguiente
            </v-btn>Una vez corroborada la identidad del alumno y la exactitud del grupo, se debe presionar el botón Siguiente. Esta acción confirma que toda la información previa es correcta y permite avanzar formalmente a la interfaz de procesamiento de pagos.
          </div>

          <div class="flex">
            <v-switch label="Seleccionar otro grupo" hide-details></v-switch>
            Al seleccionar “Datos hermano”, el sistema mostrará detalladamente de cada alumno, su nombre, matrícula, grupo actual y el nivel al que avanzarán. En caso de que se requiera asignar un grupo distinto al sugerido por el sistema, se debe utilizar la opción 'Seleccionar otro grupo'. Para realizar una búsqueda efectiva, se deberá ingresar la nomenclatura oficial: PLANTEL - CICLO - HORARIO - NIVEL
          </div>


    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green darken-1" text @click="dialogAyudaSeleccionarGrupo = false" v-bind="attrs" v-on="on">
            Cerrar
          </v-btn>
        </template>
        <span>Cerrar ventana de ayuda</span>
      </v-tooltip>
    </v-card-actions>

  </v-card>
    </v-dialog>


    <v-dialog v-model="dialogAyudaRealizarPago" max-width="900">
      <v-card>
        <v-card-title class="text-h5">Ayuda — Documentación</v-card-title>
        
        <v-card-text>


          <div class="flex" style="flex-direction: column;">
            <div class="flex">
              <b>Alumno, Matricula y Grupo: </b>Como medida de control, el sistema presentará una ventana de confirmación final donde se deberán verificar nuevamente los datos críticos: nombre del alumno, matrícula y grupo.
            </div>

            <div class="flex">
              <b style="color: gray;">Para hermanos: </b>
              <p>
                Una vez desplegada la información, se debe realizar una validación de los datos del primer alumno. Debemos corroborar que el nombre completo, la matrícula y el grupo (tanto actual como el siguiente). Asimismo, es vital confirmar que el monto a pagar refleje correctamente los descuentos
              </p>

              <p>
                Tras validar al primer estudiante, el sistema habilitará la información del siguiente alumno vinculado. Se debe repetir el proceso de cotejo de datos con la misma rigurosidad
              </p>
            </div>



          </div>

          <div class="flex">
            <b>Costo del curso, Total a pagar, Total pagado: </b>En esta sección se visualiza el importe a liquidar. Se debe realizar una validación cruzada para asegurar que el monto guarde coherencia con el porcentaje de beca asignado al alumno o tarifa vigente

          </div>

          <div class="flex">
            <v-radio-group row>
	            <v-radio
	              label="EFECTIVO"
	              :value="1"
	            ></v-radio>
	          </v-radio-group>
            Por defecto, el sistema selecciona Efectivo como método de pago predeterminado. Si el cliente utiliza este medio, el usuario únicamente deberá ingresar la cantidad recibida en el campo 'Total pagado' para proceder con la transacción
          </div>

          <div class="flex">
            <v-radio-group row>
	            <v-radio
	              label="DEPOSITO / TRANSFERENCIA"
	              :value="2"
	            ></v-radio>
	          </v-radio-group>
            Al cargar la evidencia (foto o captura), el sistema realizará una detección automática del tipo de movimiento. Identificará si se trata de un depósito, tarjeta, pago seguro o transferencia, y actualizará de forma inmediata la forma de pago
          </div>

          <div class="flex">
            <v-radio-group row>
	            <v-radio
	              label="CON FACTURA"
	              :value="4"
	            ></v-radio>
	          </v-radio-group>En caso de que el alumno o tutor requiera comprobante fiscal (factura), es indispensable marcar el recuadro correspondiente. Al activarlo, el sistema actualizará automáticamente el monto total, integrando el impuesto o cargo adicional (16%) de acuerdo con las normativas vigentes.
          </div>

          <div class="flex">
            <v-btn class="green">
              Liquidado
            </v-btn>El botón Liquidado se habilitará automáticamente cuando el sistema detecte que el monto capturado cubre la totalidad del costo del siguiente nivel educativo. Al aparecer esta opción, se confirma que el alumno ha quedado solvente
          </div>

          <div class="flex">
            <b style="color: blue;">Arrastre el archivo para cargar: </b>En caso de utilizar un método de pago distinto al efectivo (transferencia, depósito o tarjeta), es obligatorio adjuntar la evidencia correspondiente. El sistema permite cargar archivos en formato de fotografía o captura de pantalla para respaldar la validez de la transacción
          </div>

          <div class="flex">
            
            <v-autocomplete
            style="width: 12rem;"
              label="Total pagado"
              filled
              dense
              single-line
              hide-details
              clearable
            ></v-autocomplete>
            En este campo se debe de ingresar manualmente el monto pagado por el alumno o tutor.
          </div>

          <div class="flex">
            
            <v-autocomplete
            style="width: 12rem;"
              label="Correo del alumno"
              filled
              dense
              single-line
              hide-details
              clearable
            ></v-autocomplete>
            En el campo de contacto, el usuario deberá ingresar manualmente la dirección de correo electrónico del alumno o tutor. Se recomienda consultar el dato directamente en el registro del estudiante o solicitarlo al interesado en el momento, ya que este campo no se autocompleta y es indispensable para el envío del comprobante de pago.
          </div>

          <div class="flex">
            <v-btn class="black" style="color: white">
              REGRESAR
            </v-btn>Si se decide no proceder con la transacción, el botón Regresar permite cancelar la operación antes de que se registre en el sistema. Al seleccionarlo, el usuario será redirigido a la pantalla de verificación de grupos, donde podrá revisar nuevamente el grado actual y el siguiente nivel del alumno.
          </div>

          <div class="flex">
            <v-btn class="blue" style="color: white">
              PROCESAR
            </v-btn>
            funciona para ingresar el pago
          </div>


    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green darken-1" text @click="dialogAyudaRealizarPago = false" v-bind="attrs" v-on="on">
            Cerrar
          </v-btn>
        </template>
        <span>Cerrar ventana de ayuda</span>
      </v-tooltip>
    </v-card-actions>

  </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import axios from 'axios';
  var moment = require('moment');
  moment.locale();
  import XLSX from 'xlsx'
  import { mapGetters } from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import dialogHistorial       from '@/components/cambios/dialogHistorial.vue';
  import dialogRechazar        from '@/components/cambios/dialogRechazar.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  import NuevoAlumno             from '@/components/inscripciones/steppers/NuevoAlumno.vue'
  import SeleccionaGrupoHermanosRI from '@/components/inscripciones/steppers/SeleccionaGrupoHermanosRI.vue'
  import SeleccionaGrupoHermanos   from '@/components/inscripciones/steppers/SeleccionaGrupoHermanos.vue'
  import SeleccionaGrupoAlumno     from '@/components/inscripciones/steppers/SeleccionaGrupoAlumno.vue'
  import SeleccionaGrupoAlumnoRI   from '@/components/inscripciones/steppers/SeleccionaGrupoAlumnoRI.vue'
  import RealizarPagoHermanos      from '@/components/inscripciones/steppers/RealizarPagoHermanos.vue'
  import RealizarPagoHermanosRI    from '@/components/inscripciones/steppers/RealizarPagoHermanosRI.vue'
  import RealizarPagoAlumno        from '@/components/inscripciones/steppers/RealizarPagoAlumno.vue'
  import RealizarPagoAlumnoRI      from '@/components/inscripciones/steppers/RealizarPagoAlumnoRI.vue'
  import RealizarPagoAlumnoRIF     from '@/components/inscripciones/steppers/RealizarPagoAlumnoRIF.vue'
  import RealizarPagoAlumnoRIA     from '@/components/inscripciones/steppers/RealizarPagoAlumnoRIA.vue'


  export default {

    components:{
      Alerta,
      carga,
      dialogHistorial,
      dialogRechazar,
      NuevoAlumno,
      SeleccionaGrupoHermanos,
      RealizarPagoHermanos,
      SeleccionaGrupoAlumno,
      RealizarPagoAlumno,
      SeleccionaGrupoAlumnoRI,
      RealizarPagoAlumnoRI,
      SeleccionaGrupoHermanosRI,
      RealizarPagoHermanosRI,
      RealizarPagoAlumnoRIF,
      RealizarPagoAlumnoRIA
    },

    mixins: [ validarErrores, funcionesExcel ],

    props: ['reporteTexto','dialogAddAlumno'],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      paso: 1,

      hermanos:[],

      tipociclo:'',
      grupos:[],
      nuevoGrupo:null,
      tipocambios:[],
      tipoCambio:null,
      alumnos:[],

      dialogUpdateCambio: false,
      alumno:{
        nombre:'',
        apellido_paterno:'',
        apellido_materno:'',
        telefono:'',
        celular:'',
        id_tipo_alumno:'1',
        id_usuario_ultimo_cambio:0,
        matricula:'',
        edad:'',
        ocupacion:'Estudiante',
        id_contacto:0,
        unidad_negocio:0,
        id_prospecto:null,
        id_empleado: null,
        folio_rh: null,
        tutor: null,
        matricula_erp:'',
        iderp:0,
        grupo: null
      },
      dialogSuccess:false,
      successMensaje:'',
      dialogRechazar:false,
      mensajeRechazo:'',
      dialogMensajes: false,
      mensajes:[],
      dialogAddCambios: false,

      teachers: [],

      grupoAlumnos:   [],
      grupoAnterior:  null,
      
      dialogAddCambio:false,
      loading:        false,
      disabled:       false,

      total_a_pagar: 0,
      precios:[],

      dataGrupoActual: null,
      dataNuevoGrupo:null,
      precioSeleccionado2: null,
      descuentoHermanos:0,

      url:'',

      imagen: null,
      dialogImagen: false,
      dialogAyuda: false,
      dialogAyudaSeleccionarGrupo: false,
      dialogAyudaRealizarPago: false,
      

      paramsHistorial: {
        estatus: false
      },

      paramsRechazo: {
        estatus: false
      },

      infoAlumno:{},
      steppers:{
      	paso: 1,
        factura: false,
        app: false
      },

      seleccionTipoAlumno:{
        opAlumno:0,
        tipoAlumno:0,
      },

      tutor:{
				nombre:'',
				apellido_paterno:'',
				apellido_materno:'',
				telefono:'',
				celular:'',
				tipo_parentesco:0,
				id_usuario_ultimo_cambio:0
			},

    }),

    watch:{

    	hermanos( val ){ 
    		console.log( val)
    	},

      alumno( val ){
        console.log( val, 'alumno')
      }

    },

    async created () {
      console.clear()

      this.url = axios.defaults.baseURL + 'evidencia-cambios/'
      this.alumno.id_usuario_ultimo_cambio = this.getdatosUsuarioERPERP.iderp

    },

    methods: {

    },

    computed:{
      ...mapGetters ('login',['getdatosUsuarioERPERP']),
    }
  }
</script>

<style>

  .v-menu__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-menu__content::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar-button:increment,.v-menu__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-menu__content::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }
</style>